import { useState, useEffect } from "react";
import config from "../../config";

export default function Prices(props) {
	const [priceData, setPriceData] = useState(null);

	useEffect(() => {
		if (!priceData) {
			fetch(config.apiRoot+'prices')
				.then(res => res.json())
				.then(json => setPriceData(json.results))
		}
	}, []);

	const formatPrice = (n) => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
	//const formatPrice = (n) => n > 10000 ? n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : n;

	return <div className={props.className}>

		<h2>{window.l('Aðgangseyrir')}</h2>
		{
			priceData && <table className="w-full">
				<tbody>
					{
						priceData.map((item, index) => <tr key={index}><td>{item['name_'+props.currentLang]}</td><td className="text-sam_red">{item.price > 0 ? formatPrice(item.price)+' kr.' : window.l('Ókeypis')}</td></tr>)
					}
				</tbody>
			</table>
		}

	</div>;
}

